import EditPresenter from 'components/features/Edit/presenter';
import { MESSAGE_PLACEHOLDER } from 'constants/message';
import { appSelector } from 'modules/app/appSelector';
import { appSlice } from 'modules/app/appSlice';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const Edit: React.VFC = () => {
	const dispatch = useDispatch();
	const name = useSelector(appSelector.selectName);
	const job = useSelector(appSelector.selectJob);
	const sex = useSelector(appSelector.selectSex);
	const serif = useSelector(appSelector.selectSerif);

	const handleChangeName = (text: string) => {
		dispatch(appSlice.actions.saveName(text));
	};

	const handleChangeJob = (text: string) => {
		dispatch(appSlice.actions.saveJob(text));
	};

	const handleChangeSex = (text: string) => {
		dispatch(appSlice.actions.saveSex(text));
	};

	const handleChangeSerif = (text: string) => {
		dispatch(appSlice.actions.saveSerif(text));
	};

	return (
		<EditPresenter
			values={{
				name,
				job,
				sex,
				serif,
			}}
			placeholders={{
				name: MESSAGE_PLACEHOLDER.name,
				job: MESSAGE_PLACEHOLDER.job,
				sex: MESSAGE_PLACEHOLDER.sex,
				serif: MESSAGE_PLACEHOLDER.serif,
			}}
			onChanges={{
				name: handleChangeName,
				job: handleChangeJob,
				sex: handleChangeSex,
				serif: handleChangeSerif,
			}}
		/>
	);
};

export default Edit;
